/**
 * Basic email validation used in Subscribers UI.
 */
export const isValidEmail = (email) => {
  const value = String(email ?? "");
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return regex.test(value) && value !== "";
};

